import React, { Component } from "react";
import "./FetchData.css";
import { SiteTitle } from "./SiteTitle";
import { TabLogin } from "./Tab";
import MaintenancePage from "./Maintenance_Page/MaintenancePage";

export class Login extends Component {
  static displayName = Login.name;

  constructor(props) {
    super(props);
    this.state = { activeTab: '1', isMaintenance: false }; // 設置 isMaintenance 為 true 以顯示維護頁面
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  }

  render() {
    const titleMap = {
      '1': '登入',
      '4': 'NYCU登入',
      '2': '註冊',
      '3': '忘記密碼',
    };

    if (this.state.isMaintenance) {
      return <MaintenancePage />;
    }

    return (
      <div>
        <SiteTitle />
        <div className="mt-5">
          <h1 id="tableLabel" className='mb-3'>{titleMap[this.state.activeTab]}</h1>
          <TabLogin activeTab={this.state.activeTab} onTabChange={this.handleTabChange} />
        </div>
      </div>
    );
  }
}
